import { Card } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import { ReorderableItems } from "@/src/components/reorderable";
import { FieldsSection, ScoreInterval, Field } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { updateOrPush, uid } from "@/src/utils/utils";
import { useState } from "react";
import { MdOutlineDragIndicator } from "react-icons/md";
import { FieldScoreIntervals } from "../../hospitalisation/scoresHook";
import FieldForm from "./fieldForm";

export default function ReorderableFields({
  allSections,
  scoreIntervals,
  currentValue,
  onChange,
  onAddClick,
  onScoreIntervalsChange,
}: {
  allSections: (FieldsSection | null | undefined)[];
  scoreIntervals: (ScoreInterval | null | undefined)[] | undefined | null;
  currentValue: (Field | null | undefined)[];
  onChange: (newValue: (Field | null | undefined)[]) => void;
  onAddClick: () => void;
  onScoreIntervalsChange:
    | ((newValue: (ScoreInterval | null | undefined)[]) => void)
    | null
    | undefined;
}) {
  let [fields, setFields] = useState(currentValue);

  async function openFieldForm(field: Field | null | undefined) {
    if (!field) return;
    await openDrawer({
      title: "Champ",
      content: (
        <FieldForm
          sections={allSections}
          currentData={field}
          onChange={(newValue) => {
            field = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        if (!field) return;
        let inserted = await apiFetch("fields", "addOne", { field });
        if (!inserted) return;
        let data = [...fields];
        data = updateOrPush(data, inserted, (f) => f?.id == inserted?.id);
        setFields(data);
        onChange(data!);
      },
    });
  }

  function removeField(field: Field | null | undefined) {
    if (!field) return;
    setFields([...fields.filter((f) => f?.id != field?.id)]);
    onChange([...fields.filter((f) => f?.id != field?.id)]);
  }

  return (
    <div className="grid c1 gap10">
      <div className="grid c1 gap10">
        <ReorderableItems
          items={fields || []}
          listId="fielsList"
          listType={"fielsList"}
          onAddClick={onAddClick}
          addButtonTitle={"Ajouter un champ"}
          onReorder={(newItems) => {
            onChange(newItems);
            setFields(newItems);
          }}
        >
          {fields?.map((field) => {
            if (!field) return null;

            let optionsStr = field?.options
              ?.filter((option) => option)
              ?.map((option) => option?.name)
              .join(", ");

            return (
              <Card
                key={uid()}
                color="simple"
                title={field?.name || "Champ sans nom"}
                leading={
                  <div
                    className="grab disabled"
                    onClick={async () => {
                      let newField = {
                        ...field,
                        id: null,
                      };
                      await openFieldForm(newField);
                    }}
                  >
                    <MdOutlineDragIndicator size={15} />
                  </div>
                }
                subTitle={field.unit?.name}
                onEdit={async () => {
                  await openFieldForm(field);
                }}
                onDelete={async () => {
                  removeField(field);
                }}
              >
                <div className="c1 gap10">
                  <div className="gray">{field.type}</div>
                  {onScoreIntervalsChange == null && (
                    <div className="gray">{optionsStr}</div>
                  )}

                  <FieldScoreIntervals
                    field={field}
                    onScoreIntervalsChange={onScoreIntervalsChange}
                    scoreIntervals={scoreIntervals || []}
                  ></FieldScoreIntervals>
                </div>
              </Card>
            );
          })}
        </ReorderableItems>
      </div>
    </div>
  );
}
